// Takroriy so'rov kaliti (`Idempotency-Key`).
//
// NEGA `shared/` DA: kalit yasash mexanizm emas, MEXANIZMNING SHARTI.
// Backend uni ikki joyda majburiy qiladi (`ExpenseController`,
// `StockResource`) va u yerdagi izohlar bir xil narsani aytadi: kalit
// SO'ROV UCHUN emas, AMAL UCHUN yasaladi — "Saqlash" qayta bosilganda
// yoki tarmoq uzilib urinish takrorlanganda U O'ZGARMASLIGI shart
// (`QARORLAR.md` §20.9-D).
//
// ⚠️ `features/inventory/stockApi.ts` da bunga o'xshash funksiya
// ALLAQACHON bor va u shu faylga KO'CHIRILMADI: `features/inventory/**`
// bugun boshqa agent egaligida va bir vaqtda ikki tomondan
// o'zgartirilmaydi. Yangi kod shu yerdagisini ishlatadi, ombor moduli
// keyingi tegilganda o'tadi — takror shu bilan tugaydi, ko'paymaydi
// (07-FRONTEND.md §6: umumiy narsa `shared/` ga chiqadi).

/**
 * Bir martalik kalit.
 *
 * ⚠️ `crypto.randomUUID` HAR JOYDA MAVJUD EMAS: u xavfsiz kontekst
 * (HTTPS yoki `localhost`) talab qiladi. Panel ba'zan IP orqali, oddiy
 * HTTP ustidan ochiladi (`10.10.10.10`) va o'sha yerda funksiya
 * `undefined` bo'ladi — tekshiruvsiz chaqiruv butun oynani yiqitardi.
 * Zaxira variant kriptografik emas, lekin bu yerda shart ham emas:
 * kalitdan talab — TAKRORLANMASLIK, sir bo'lish emas.
 *
 * @param prefix jurnalda kalit qaysi oynadan kelganini ko'rsatadi
 */
export function newIdempotencyKey(prefix: string): string {
  const cryptoApi = globalThis.crypto as Crypto | undefined
  if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
    return `${prefix}-${cryptoApi.randomUUID()}`
  }
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
}
